import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Combos/getComboLineaGeneticaGranja`, method: 'POST', body: values, token: token})
}